import { useState } from "react";
import { useParams } from "react-router-dom";

import { useAuth } from "@/context/auth-context";
import { usePromptRegistry, usePromptVersion } from "@/queries";
import useXRayPromptBlueprint from "@/queries/playground/useXRayBlueprint";
import { PromptBlueprint } from "@/types";

const useDiffVersions = () => {
  const auth = useAuth();
  const userToken = auth!.userToken!;
  const { promptId, versionNumber, diffVersionNumber } = useParams();

  const [isXrayMode, setIsXrayMode] = useState(false);

  const promptRegistryQuery = usePromptRegistry(userToken, Number(promptId));
  const sourceVersionQuery = usePromptVersion(userToken, Number(promptId), Number(versionNumber));
  const targetVersionQuery = usePromptVersion(
    userToken,
    Number(promptId),
    Number(diffVersionNumber),
  );

  const sourceVersion = sourceVersionQuery.data;
  const targetVersion = targetVersionQuery.data;

  const sourceXray = useXRayPromptBlueprint(
    (sourceVersion as PromptBlueprint) ?? ({} as PromptBlueprint),
    !!sourceVersion,
  );
  const targetXray = useXRayPromptBlueprint(
    (targetVersion as PromptBlueprint) ?? ({} as PromptBlueprint),
    !!targetVersion,
  );

  const isXrayAvailable = !!(sourceXray.data?.expanded || targetXray.data?.expanded);

  const sourceTemplate = isXrayMode
    ? (sourceXray.data?.prompt_blueprint?.prompt_template ?? sourceVersion?.prompt_template)
    : sourceVersion?.prompt_template;

  const targetTemplate = isXrayMode
    ? (targetXray.data?.prompt_blueprint?.prompt_template ?? targetVersion?.prompt_template)
    : targetVersion?.prompt_template;

  const isLoading =
    promptRegistryQuery.isLoading || sourceVersionQuery.isLoading || targetVersionQuery.isLoading;

  return {
    promptId,
    versionNumber,
    diffVersionNumber,
    promptRegistry: promptRegistryQuery.data,
    sourceVersion,
    targetVersion,
    sourceTemplate,
    targetTemplate,
    isLoading,
    isXrayMode,
    setIsXrayMode,
    isXrayAvailable,
  };
};

export default useDiffVersions;
